import { UseFormRegisterReturn } from "react-hook-form"
import { StyledIntegerInput, IntegerInputContainer } from "./IntegerInput.styled"

interface IntegerInputProps {
  /**
   * The React Hook Form register return object
   */
  registerReturn: UseFormRegisterReturn
  /**
   * Optional placeholder text
   */
  placeholder?: string
  /**
   * Optional minimum value
   */
  min?: number
  /**
   * Optional maximum value
   */
  max?: number
  /**
   * Optional callback when the input value changes
   */
  onChange?: () => void
}

/**
 * Generic IntegerInput component for React Hook Form.
 * This component renders a styled HTML number input with React Hook Form integration
 * and validates that the input is an integer.
 * All other validations are controlled externally through register options.
 *
 * @example
 * ```tsx
 * <IntegerInput
 *   registerReturn={register("quantity", { required: "Quantity is required" })}
 *   min={1}
 * />
 * ```
 */
export const IntegerInput = ({
  registerReturn,
  placeholder,
  min,
  max,
  onChange,
}: IntegerInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (registerReturn.onChange) {
      registerReturn.onChange(e)
    }
    if (onChange) {
      onChange()
    }
  }

  return (
    <IntegerInputContainer alignItems="center">
      <StyledIntegerInput
        type="number"
        placeholder={placeholder}
        min={min}
        max={max}
        step={1}
        {...registerReturn}
        onChange={handleChange}
      />
    </IntegerInputContainer>
  )
}
